<template>
  <div>
    <div class="page404">
      <h2 v-translate>Navigart ne peut pas s'afficher dans votre navigateur car les cookies semblent désactivés.</h2>
    </div>
  </div>
</template>

<script>
export default {
  name: 'CookiesRequired',
};
</script>
